import { render, staticRenderFns } from "./ai-usage-declaration.vue?vue&type=template&id=f5126b78&scoped=true&lang=html"
import script from "./ai-usage-declaration.vue?vue&type=script&lang=js"
export * from "./ai-usage-declaration.vue?vue&type=script&lang=js"
import style0 from "./ai-usage-declaration.vue?vue&type=style&index=0&id=f5126b78&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5126b78",
  null
  
)

export default component.exports